__turbopack_context__.v({
  "btn": "s6kIGq_btn",
  "btnContent": "s6kIGq_btnContent",
  "btnFooter": "s6kIGq_btnFooter",
  "btnIcon": "s6kIGq_btnIcon",
  "btnText": "s6kIGq_btnText",
  "cards": "s6kIGq_cards",
  "content": "s6kIGq_content",
  "headContact": "s6kIGq_headContact",
  "imgbabyAI": "s6kIGq_imgbabyAI",
  "imgbabyText": "s6kIGq_imgbabyText",
  "p": "s6kIGq_p",
  "page-body-wrap": "s6kIGq_page-body-wrap",
  "pagehero": "s6kIGq_pagehero",
  "paragraph": "s6kIGq_paragraph",
  "paragraph-content": "s6kIGq_paragraph-content",
  "t": "s6kIGq_t",
  "title": "s6kIGq_title",
  "wrap-container": "s6kIGq_wrap-container",
  "wrap-content": "s6kIGq_wrap-content",
});
